import { useAppSelector } from 'flow/hooks/useRedux';
import {
    selectChannelActiveProfile,
    selectChannelEditable,
} from 'flow/selectors/channel-selectors';
import { ChannelKey } from 'flow/types/EntityKeys';
import ActiveProfile from '../ActiveProfile';

interface Props {
    channelKey: ChannelKey;
}

const LiveChatActiveProfile = ({ channelKey }: Props) => {
    const isEditable = useAppSelector((state) =>
        selectChannelEditable(state, channelKey),
    );
    const activeProfile = useAppSelector((state) =>
        selectChannelActiveProfile(state, channelKey),
    );

    return (
        <ActiveProfile
            entityKey={channelKey}
            isEditable={isEditable}
            routeKey="pbx.channels.entityKey.profiles"
            activeProfile={activeProfile}
        />
    );
};

export default LiveChatActiveProfile;
